import * as React from "react";
import Modal3DPreview from "../../helper/3DModalPreview";

const Modal3D = (props) => {
  let ManufacturerName = props && props.value && props.value.ManufacturerName;
  let ManufacturerPartNumber = props && props.value && props.value.ManufacturerPartNumber;
  let ERPMFRPartNumber = props && props.value && props.value.ERPMFRPartNumber;

  const imgAmerica = `https://avnet.componentsearchengine.com/icon.php?mna=${ManufacturerName}&mpn=${ERPMFRPartNumber}&lbl=1&lbc=000000&q3=1`


  function onModalOpen(e) {
    e.preventDefault();

    Modal3DPreview.loadSpeedBoatViseScript(
      ManufacturerName,
      ManufacturerPartNumber,
      'avnet',
      1,
      "zip",
      0,
      "",
      "en-GB",
      1, "", 0
    );
  }
  return (
    <>
      <div className="cad-link" onClick={onModalOpen}>
        <a href={void 0}>
          <img alt="PCB Symbol, Footprint & 3D Model"
            src={imgAmerica}
          />
        </a>
      </div>
    </>
  );
};

export default Modal3D;
